import { addMicrotask, GemError } from './utils';
export const StoreListenerMap = new WeakMap();
export function createStore(originStore) {
    if (StoreListenerMap.has(originStore)) {
        throw new GemError('argument error');
    }
    StoreListenerMap.set(originStore, new Set());
    return originStore;
}
export function createStoreSet(originStoreSet) {
    const keys = Object.keys(originStoreSet);
    keys.forEach((key) => {
        createStore(originStoreSet[key]);
    });
    return originStoreSet;
}
export function updateStore(store, value) {
    Object.assign(store, value);
    const listeners = StoreListenerMap.get(store);
    listeners === null || listeners === void 0 ? void 0 : listeners.forEach((func) => {
        addMicrotask(func);
    });
}
export function connect(store, func) {
    const listeners = StoreListenerMap.get(store);
    listeners === null || listeners === void 0 ? void 0 : listeners.add(func);
}
export function disconnect(store, func) {
    const listeners = StoreListenerMap.get(store);
    listeners === null || listeners === void 0 ? void 0 : listeners.delete(func);
}
//# sourceMappingURL=store.js.map